import { createMemo } from 'solid-js'
import { twMerge } from 'tailwind-merge'
import type { ListItemSecondaryActionPropsType } from '~/types/ListItemSecondaryAction'

export default function ListItemSecondaryAction(props: ListItemSecondaryActionPropsType) {
  const actionClasses = createMemo(() => twMerge('flex items-center justify-center flex-shrink-0', 'ml-auto', props.class))

  return (
    <div class={actionClasses()} classList={props.classList}>
      {props.children}
    </div>
  )
}
